/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'
import Dropdown from '../../../../components/Dropdown'
import { usePatientStatusChangeMutation } from '../../../../slices/patientSlice'
import Loader from '../../../../components/Loader'
import PatientProviderList from './Table/Index'
import MonitorViewTable from './MonitorViewTable/monitorViewTable'
import ObserverViewTable from './ObserverTable/PatientObserverTable'


export default function ViewPatientDetails({ patientDetails, date }) {
    const [statusChange] = usePatientStatusChangeMutation()
    const [editPatientStatus, setEditPatientStatus] = useState(false)
    const [threedotLoader, setThreedotLoader] = useState(false)
    const [editPatientStatusDetails, setEditPatientStatusDetails] = useState({
        "patient_status": "",
        "monitoring_status": ""
    })

    const handleOnChangeUserDetails = (key, value) => {
        // Update the state with the new value
        setEditPatientStatusDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleStatusChange = async () => {
        setThreedotLoader(true)
        const id = patientDetails?.patient_id
        let body =
        {
            "patient_status": editPatientStatusDetails.patient_status,
            "monitoring_status": editPatientStatusDetails.monitoring_status
        }
        const response = await statusChange({ id, body })
        setThreedotLoader(false)
    }

    useEffect(() => {
        setEditPatientStatusDetails(prevState => ({
            ...prevState,
            "patient_status": patientDetails?.patient_status,
            "monitoring_status": patientDetails?.monitoring_status
        }));
    }, [editPatientStatus])

    return (
        <div className=" p-1.5 mt-[26px] border border-[#E7CBD2] rounded-lg mx-[28px]">
            <div className="w-full px-4 py-6 h-[calc(100vh-382px)] overflow-auto scrollbar_grayw6 ">
                <section>
                    <div className='flex items-center mb-3.5'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Basic Details</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="flex -mx-1 flex-wrap">
                        <div className="w-full px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Username</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.user_name}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Email Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.email_address !== "" ? patientDetails?.email_address : '-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.mobile_number !== "" ? patientDetails.country_code2 + "\t" + formatMobileNumber(patientDetails?.mobile_number) : "-"}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Main Number</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails.country_code1} {formatMobileNumber(patientDetails.main_number)}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Date of Birth</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.date_of_birth !== "" ? patientDetails?.date_of_birth : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Age</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.age !== "" ? patientDetails?.age : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Gender</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.gender !== "" ? patientDetails?.gender : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-full px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Address</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails.address !== "" ? patientDetails.address : '-'}</p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Primary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.primary_identifier !== "" ? patientDetails?.primary_identifier : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Secondary Identifier</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.secondary_identifier !== "" ? patientDetails?.secondary_identifier : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Onboarding Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.onboarding_date !== "" ? patientDetails?.onboarding_date : '-'}
                                </p>
                            </div>
                        </div>
                        <div className="w-1/3 px-1 mb-6">
                            <div className="flex -mx-1">
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(kg)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.weight_kgs !== "" ? patientDetails?.weight_kgs : '-'}
                                        </p>
                                    </div>
                                </div>
                                <div className="w-1/2 px-1">
                                    <div className="w-full">
                                        <p className="text-sm font-normal text-[#000]">Weight(lbs)</p>
                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                            {patientDetails?.weight_lbs !== "" ? patientDetails?.weight_lbs : '-'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Patient Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.patient_status !== "" ? patientDetails?.patient_status : '-'}
                                </p>
                            </div>
                        </div>
                        {/*<div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Status</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.monitoring_status !== "" ? patientDetails?.monitoring_status : '-'}
                                </p>
                            </div>
                        </div>*/}
                        <div className="w-1/3 px-1 mb-6">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Monitoring Cycle Start Date</p>
                                <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                    {patientDetails?.monitoring_cycle !== "" ? patientDetails?.monitoring_cycle : '-'}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Active Alerts</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="flex gap-36 flex-wrap mb-6">
                        <div className="flex-shrink-0">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Alerts by SMS</p>
                                <div className="pt-2">
                                    <span className={`inline-flex items-center justify-center ${patientDetails?.sms_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                        <span className="text-xs">{patientDetails?.sms_alert === true ? "ON" : "OFF"}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Alerts by Email</p>
                                <div className="pt-2">
                                    <span className={`inline-flex items-center justify-center ${patientDetails?.email_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                        <span className="text-xs">{patientDetails?.email_alert === true ? "ON" : "OFF"}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Include Missed Readings</p>
                                <div className="pt-2">
                                    <span className={`inline-flex items-center justify-center ${patientDetails?.missed_reading_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                        <span className="text-xs">{patientDetails?.missed_reading_alert === true ? "ON" : "OFF"}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <div className="w-full">
                                <p className="text-sm font-normal text-[#000]">Receive Readings Acknowledgement</p>
                                <div className="pt-2">
                                    <span className={`inline-flex items-center justify-center ${patientDetails?.reading_received_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                        <span className="text-xs">{patientDetails?.reading_received_alert === true ? "ON" : "OFF"}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Patient Status</h1>
                        <div className='relative w-full h-[1px] bg-[#008586]  ml-3 down-arraow'></div>
                    </div>
                    <div className="flex bg-[#E5F3F3] border justify-between border-transparent rounded-[4px] py-3 px-2.5 -mx-[7px] flex-wrap mb-[20px]">
                        <div className="flex">
                            <div className="tm:ml-[40px] ml-0">
                                <p className="text-sm font-normal text-[#000]">Status</p>
                                {!editPatientStatus ?
                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                        {patientDetails?.patient_status}</p>
                                    :
                                    <div className='w-[220px]'>
                                        <div className='w-full'>
                                            <Dropdown
                                                // label={"Patient Status*"}
                                                id={"patient_status"}
                                                placeholder={editPatientStatusDetails.patient_status === '' ? 'Select patient status' : editPatientStatusDetails.patient_status}
                                                data_testid={"patient_status"}
                                                value={editPatientStatusDetails?.patient_status}
                                                options={['At Home', 'Hospitalized', 'Away', 'Deceased']}
                                                emptyField={editPatientStatusDetails.patient_status === ''}
                                                handleOnChangeInput={handleOnChangeUserDetails}
                                            />
                                        </div>
                                    </div>}
                            </div>
                            <div className="xl:ml-[140px] ml-10 ">
                                <p className="text-sm font-normal text-[#000]">Monitoring Status</p>
                                {!editPatientStatus ?
                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                        {patientDetails?.monitoring_status}</p>
                                    :
                                    <div className='w-full'>
                                        <div className='flex items-center pt-[7px]'>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input id="monitored" type="radio" name="default-radio1" checked={editPatientStatusDetails?.monitoring_status === 'Monitored'} onChange={() => handleOnChangeUserDetails("monitoring_status", 'Monitored')} />
                                                    <label htmlFor="monitored" className={`text-base font-normal ${editPatientStatusDetails?.monitoring_status === 'Monitored' ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                        Monitored
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center" >
                                                    <input id="not_monitored" type="radio" name="default-radio1" checked={editPatientStatusDetails?.monitoring_status === 'Not Monitored'} onChange={() => handleOnChangeUserDetails("monitoring_status", "Not Monitored")} />
                                                    <label htmlFor="not_monitored" className={`text-base font-normal ${editPatientStatusDetails?.monitoring_status === 'Not Monitored' ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                        Not Monitored
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                            </div></div>

                        {!editPatientStatus ?
                            <button
                                onClick={() => { setEditPatientStatus(true) }}
                                id="edit" className={`min-w-max px-4 py-1.5 hover:bg-[#EDD7E1] bg-white border border-[#972E4C] h-fit rounded-[16px] flex items-center`}>
                                <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                            </button>
                            :
                            <div className='flex mt-[10px]  -mx-2.5'>
                                <div className='px-2.5 w-1/2'>
                                    <button
                                        onClick={() => setEditPatientStatus(false)}
                                        id="Cancel"
                                        // disabled={disabled}
                                        className="py-2.5 px-4 rounded-[16px] bg-white border border-[#972E4C] text-lg font-semibold text-[#972E4C] w-full"
                                    > {'Cancel'}
                                    </button>
                                </div>
                                <div className='px-2.5 w-1/2'>
                                    <button
                                        onClick={() => handleStatusChange()}
                                        id="Cancel"
                                        // disabled={disabled}
                                        className={`py-2.5 px-4 rounded-[16px] border border-[#972E4C]  hover:bg-[#AB556E] bg-[#972E4C] focus:bg-[#863B50] text-lg mr-10 font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf w-[120px]`}>
                                        {threedotLoader ? <span><Loader /></span> : 'Update'}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </section>
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Minimum Readings Conditions (By Default {patientDetails?.defaultReadings?.number_of_readings !== null ? patientDetails?.defaultReadings?.number_of_readings : '0'} Readings In {patientDetails?.defaultReadings?.number_of_time_periods !== null ? patientDetails?.defaultReadings?.number_of_time_periods : '0'} {patientDetails?.defaultReadings?.time_period}  )</h1>
                        <div className='relative w-full h-[1px] bg-[#008586]  ml-3 down-arraow'></div>
                    </div>
                    <div className="flex bg-[#E5F3F3] border border-transparent rounded-[4px] py-3 px-2.5 -mx-[7px] flex-wrap mb-[20px]">
                        <div className="ml-[40px]">
                            <p className="text-sm font-normal text-[#000]">Readings</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.number_of_readings}</p>
                        </div>
                        <div className="mx-[40px]">
                            <p className="text-sm font-normal text-[#000]">Number of Days</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.number_of_time_periods}</p>
                        </div>
                        <div className="">
                            <p className="text-sm font-normal text-[#000]">Time Period</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.time_period}</p>
                        </div>
                    </div>
                </section>
                {
                    (patientDetails?.contacts?.length > 0 || patientDetails?.case_managers?.length > 0) &&
                    <section>
                        <div className='flex items-center mb-3.5 mt-1'>
                            <h1 className='text-lg font-normal text-[#000000] min-w-max'>Additional Contact Details</h1>
                            <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                        </div>
                        <div className="flex -mx-[7px] flex-wrap">

                            {patientDetails?.contacts?.length > 0 &&
                                <div className="w-1/2 px-[7px] mb-6">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Emergency Contact Details (First entry is highest priority)</h1>
                                        <div className='px-2.5'>
                                            {patientDetails.contacts.map((contact, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.name !== "" ? contact.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {contact.contact_number !== "" ?
                                                                    contact.country_code + "\t" + formatMobileNumber(contact.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {patientDetails?.case_managers?.length > 0 &&
                                <div className="w-1/2 px-[7px] mb-6">
                                    <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                        <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Case Manager Contact Details (First entry is highest priority) </h1>
                                        <div className='px-2.5'>
                                            {patientDetails?.case_managers.map((caseManager, index) => (
                                                <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.name !== "" ? caseManager.name : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-1/2 pl-2.5 pr-1'>
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {caseManager.contact_number !== "" ?
                                                                    caseManager.country_code + "\t" + formatMobileNumber(caseManager.contact_number) :
                                                                    "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </section>
                }
                <section>
                    <div className='flex items-center mb-3.5 mt-1'>
                        <h1 className='text-lg font-normal text-[#000000] min-w-max'>Organizational Assignment and User Associations</h1>
                        <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                    </div>
                    <div className="w-full px-1 mb-6 flex">
                        <div className="w-1/2">
                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.organization_name}</p>
                        </div>
                        <div className="w-1/2">
                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                {patientDetails?.subdivision_name}</p>
                        </div>
                    </div>
                </section>
                <section>
                    <MonitorViewTable
                        patient_id={patientDetails?.patient_id} />

                    <PatientProviderList
                        patient_id={patientDetails?.patient_id}
                    />
                    <ObserverViewTable
                        patient_id={patientDetails?.patient_id}
                    />
                </section>
            </div >
        </div >
    )
}
